<template>
  <div style="padding-top: 20px">
    <div
      class="card page mb-5 p-2"
      style="width: 1200px; margin: 0 auto; box-shadow: 10px 10px 5px #888888"
      id="v-content"
    >
      <p style="margin-bottom: 20px">
        <span
          class="float-right span_close"
          style="
            display: block;
            width: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 25px;
          "
          @click="$router.go(-1)"
        >
          &times;
        </span>
      </p>
      <div style="width: 1000px; margin: 0 auto">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="departmentname" label="部门名称">
          </el-table-column>
          <el-table-column label="评价等级">
            <template slot-scope="scope">
              <el-rate
                v-model="scope.row.pf"
                show-text
                text-color="#d50606"
                :texts="['非常差', '差', '一般', '好', '非常好']"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              >
              </el-rate>
            </template>
          </el-table-column>
          <el-table-column label="留言">
            <template slot-scope="scope">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入留言"
                v-model="scope.row.context"
              >
              </el-input>
            </template>
          </el-table-column>
        </el-table>
        <el-row :gutter="20" type="flex" justify="end" style="margin-top: 20px">
          <el-button type="primary" @click="submit">提交评价</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      form: {
        listobjs: [],
        rkdh: "入库单号",
      },
    };
  },
  methods: {
    GetBm() {
      this.$http.post("Evaluate/GetBm", {}).then((res) => {
        if (res.data.isok) {
          this.tableData = res.data.data;
        }
      });
    },

    // 提交
    submit() {
      let arr = [];
      this.tableData.map((item) => {
        if (item.pf) {
          let form = {
            bumenid: item.id,
            bumenname: item.departmentname,
            pf: item.pf,
            context: item.context || "",
          };
          arr.push(form);
        }
      });

      if (this.tableData.length > arr.length) {
        this.$message.warning("你还有部门没有评分，请评价后再提交");
      } else {
        this.form.listobjs = arr;
        this.$http.post("Evaluate/AddRkPj", this.form).then((res) => {
          if (res.data.isok) {
            this.$message.success("评价成功");
            this.$router.go(-1);
          }
        });
      }
    },
  },
  created() {
    this.form.rkdh = this.$route.query.rkdh || "";
    this.GetBm();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/Pj/StorePj.vue